import { Action } from 'redux';
import { PermissionActions } from './app/app.actions';
import {IAppState} from './app/interfaces/appstate.interface';

export const INITIAL_STATE: IAppState = {
  "token": false,
  "userRoleId": 1,
  "displayName": "Admins",
  "email": "",
  "organizationId": 1,
  "sysadminSetting": null,
  "clientExposure": null,
  "clientRule": null,
  "clientRebalance": null,
  "clientOrganization": null,
  "clientSystem": null,
  "enabled": true,
  "archived": false,
  "fundAssetTrades": true,
  "hedgeAssetTrades": true,
  "fundAssetTradesImmediate": false,
  "hedgeAssetTradesImmediate": false,
  "netExternalFXOrdersImmediate": false,
  "repatriateCashImmediate": false,
  "scheduleTimeZone": "Eastern Time",
  "nextScheduledTime": null,
  "schedule": {
      "startTimes": null,
      "frequency": "DAILY",
      "daily": {
          "interval": 0
      },
      "weekly": null,
      "monthly": null,
      "yearly": null
  },
  "nettingByCurrency": false,
  "hedgeFullExposure": false,
  "liquidityProviderSelection": false,
  "liquidityProviderMethod": "MAX_NOTIONAL"
};

export function rootReducer(lastState: IAppState, action): IAppState {
  switch(action.type) {
  //  case CounterActions.INCREMENT: return { count: lastState.count + 1 };
      case PermissionActions.GET_USER_SETTINGS: return {
        ...lastState,
        ...action.payload,
      }
      case PermissionActions.GET_USER_ROLES: return {
        ...lastState,
        ...action.payload,
      }
      case PermissionActions.GET_USER_RULES: return {
        ...lastState,
        ...action.payload,
      }
      case PermissionActions.ADD_TOKEN: return {
        ...lastState,
        token: action.payload,
      }
      default: return lastState
  //  case CounterActions.DECREMENT: return { count: lastState.count - 1 };
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/store.ts